// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"126": "dingtalk-jsapi","257": "customize","28": "light-component","417": "i18next","516": "ali-oss","749": "@sentry/react",}[chunkId] + "." + {"126": "114bee17","257": "bc2e2767","28": "3b79092e","417": "dce58ccb","516": "855c9ba0","749": "d6fcc19e",}[chunkId] + ".js"
}